import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { IMaker } from 'app/interface/IBooking'

const initialState: IMaker[] = []
const makerSlice = createSlice({
  name: 'maker',
  initialState,
  reducers: {
    addMaker: (state: any, action: PayloadAction<any>) => {
      state = state.push(action.payload)
    },
    removeMaker: (state: any, action: PayloadAction<any>) => {
      state.filter((item: any) => item.typeMaker !== action.payload)
    },
  },
})
export const makerAction = makerSlice.actions
export default makerSlice
